import { ENVIRONMENT_CONFIG } from 'constants/environment';
import { delay } from 'helpers/delay';

const MAX_WAIT_TIME = ENVIRONMENT_CONFIG.http.maxWaitTime;

export async function waitBeforeRetry(retryAttempt: number): Promise<void> {
  const timeout = Math.min(1000 * 2 ** retryAttempt, MAX_WAIT_TIME);

  await delay(timeout);
}
